import React from "react"
import SeoLandingPage from "./SeoLandingPage"
import { SEO_KEYWORDS_EXTRA } from "../../seo/extraKeywords"

export default function BedAdmissionKaranjia() {
  return (
    <SeoLandingPage
      path="/b-ed-admission-karanjia"
      title="Top B.Ed Institute for Karanjia Students | Best Admission & Coaching Support"
      description="Top B.Ed admission support for Karanjia & Mayurbhanj (Thakurmunda, Andapur, Chhenapadi nearby): counselling, coaching, forms, documents, books and online classes—with Bhadrak office support."
      keywords={`best B.Ed institute Karanjia, B.Ed admission Thakurmunda, B.Ed coaching Thakurmunda, B.Ed admission Andapur, B.Ed admission Chhenapadi, top B.Ed institute Karanjia, B.Ed coaching Karanjia, B.Ed college Karanjia Mayurbhanj, B.Ed institute near me Karanjia, B.Ed consultancy Mayurbhanj, teacher training Karanjia, BP.Ed guidance Karanjia Odisha, ${SEO_KEYWORDS_EXTRA}`}
      h1="Top B.Ed Institute Support for Karanjia — Counselling + Coaching"
      intro="If you searched for the best B.Ed institute in Karanjia or top B.Ed admission help in Mayurbhanj (including Thakurmunda, Andapur and Chhenapadi areas), we provide counselling, eligibility guidance, admission processing, study materials and online coaching. Offline support is available from our Bhadrak office when you need it."
      bullets={[
        "B.Ed admission counselling for Karanjia students",
        "Online coaching/classes + study material guidance",
        "Admission processing + form fill-up assistance",
        "Document checklist and verification support",
        "Book distribution support via office",
        "Also supports nearby Mayurbhanj areas: Thakurmunda, Andapur, Chhenapadi and across the district",
      ]}
      areaServed={[
        { "@type": "City", name: "Karanjia" },
        { "@type": "Place", name: "Thakurmunda" },
        { "@type": "Place", name: "Andapur" },
        { "@type": "Place", name: "Chhenapadi" },
        { "@type": "AdministrativeArea", name: "Mayurbhanj" },
        { "@type": "State", name: "Odisha" },
      ]}
      faqs={[
        {
          q: "Which is the best B.Ed institute option for Karanjia students?",
          a: "We provide trusted B.Ed admission counselling and coaching for Karanjia students (online + Bhadrak office support), including documents, books and step-by-step admission guidance.",
        },
        {
          q: "Is this service available for Karanjia students?",
          a: "Yes. We support students from Karanjia and nearby areas for counselling, admissions and coaching.",
        },
        {
          q: "Do you provide online classes?",
          a: "Yes. Online coaching is available along with admission support and study material guidance.",
        },
        {
          q: "How can I contact you quickly?",
          a: "Call us for counselling. We can guide you on eligibility, documents and the next steps.",
        },
      ]}
    />
  )
}

